import Store from 'repatch';

import State from '../core/State';
import ErrorPresenter from '../service/ErrorPresenter';
import SearchAssetApi from '../service/persistent/SearchAssetApi';
import { setAssetFormTermAgreements } from '../thunk/project';

class SearchAssetUsecase {
  private readonly store: Store<State>;
  private readonly searchAssetApi: SearchAssetApi;
  private readonly errorPresenter: ErrorPresenter;
  constructor({
    store,
    searchAssetApi,
    errorPresenter,
  }: {
    store: Store<State>;
    searchAssetApi: SearchAssetApi;
    errorPresenter: ErrorPresenter;
  }) {
    this.store = store;
    this.searchAssetApi = searchAssetApi;
    this.errorPresenter = errorPresenter;
  }
  // GET API
  public setAssetFormTermAgreements = async (): Promise<void> => {
    const user = this.store.getState().authentication.signedInUser;
    if (user != null) {
      const isAgreed = await this.searchAssetApi.getUserTermAgreements(user.id);
      this.store.dispatch(setAssetFormTermAgreements(isAgreed));
    }
  };

  // POST
  public postAssetFormTermAgreements = async (): Promise<void> => {
    const user = this.store.getState().authentication.signedInUser;
    if (user != null) {
      try {
        await this.searchAssetApi.postUserTermAgreements();
        this.setAssetFormTermAgreements();
      } catch (error) {
        this.errorPresenter.showAsNonFatal(new Error('message.export_performance_report_request_has_failed'));
        error.log(error);
      }
    }
  };
}

export default SearchAssetUsecase;
